module.exports = __webpack_public_path__ + "static/img/4.a7e402c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/4.png
// module id = gF3u
// module chunks = 91